var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('trace-helper',{attrs:{"trace":_vm.trace}},[_c('span',{staticClass:"tag"},[_c('b',[_vm._v("gated In")])]),_vm._v(" unit "),_c('span',{staticClass:"tag"},[_c('b',[_vm._v(_vm._s(_vm.record.number))])])])}
var staticRenderFns = []

export { render, staticRenderFns }